import React, { useEffect, useState, useMemo } from "react";
import { Table, Grid } from "antd";
import axios from "axios";
import { schemeColumns } from "../columns/schemeColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn, rowMatchesSearch } from "../LedgerResponsive";
const money=v=>`₹${Number(v||0).toLocaleString()}`;
export default function SchemeTable({ folio, pan, onOpenModal, onDrillScheme, searchQuery }) {
  const screens=Grid.useBreakpoint(),isMobile=!screens.md;
  const [schemes, setSchemes] = useState([]); const [loading, setLoading] = useState(false);
  useEffect(() => { if (!folio || !pan) return; setLoading(true);
    axios.get(`${API_BASE}/get_schemes.php?folio_number=${folio}&pan=${pan}&arn_no=${getArn()}`)
      .then((res) => setSchemes(res.data && Array.isArray(res.data.schemes) ? res.data.schemes : []))
      .catch(() => setSchemes([])).finally(() => setLoading(false));
  }, [folio, pan]);
  const filtered = useMemo(() => schemes.filter(r => rowMatchesSearch(r, searchQuery)), [schemes, searchQuery]);
  const mobileColumns=[
    {title:"Scheme",dataIndex:"scheme_name",key:"scheme_name",width:"48%",ellipsis:true,render:t=><span style={{color:"#1677ff"}}>{t}</span>},
    {title:"Cost",dataIndex:"remaining_cost_value",key:"remaining_cost_value",width:"26%",align:"right",render:money},
    {title:"Current",dataIndex:"current_value",key:"current_value",width:"26%",align:"right",render:money},
  ];
  return <LedgerResponsiveWrapper><Table loading={loading} columns={isMobile?mobileColumns:schemeColumns(onOpenModal)} dataSource={filtered}
    rowKey="scheme_code" pagination={false} bordered sticky scroll={isMobile?undefined:{x:"max-content"}} tableLayout={isMobile?"fixed":"auto"} className={isMobile?"kg-mobile-nowrap-table":""}
    onRow={(record)=>({onClick:(e)=>{if(e.target.closest("button,a,[role='button']"))return;onDrillScheme?.(record);},style:{cursor:"pointer"}})} /></LedgerResponsiveWrapper>;
}
